import {Method, NetworkType} from '@/libs/wallet-connect-sdk-core/types'

export class XWalletConnectConfig {
  static readonly methods: Method[] = ['eth_sendTransaction']

  static readonly network: NetworkType = 'eip155:47763'
}
